module.exports = __webpack_public_path__ + "static/img/call.e203c904.png";